var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"content"},[_c('h3',{staticClass:"subtitle"}),_vm._v(" "),_c('h3',{staticClass:"subtitle"},[_c('i',{staticClass:"fa fa-refresh fa-spin fa-3x fa-fw"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]),_vm._v(" "),_c('h3',{staticClass:"subtitle"},[_vm._v("\n     Loading...\n    ")])])
}]

export { render, staticRenderFns }